import { CpaShopsSuggestDto, CpaSearchSuggestModel } from '../../data-layer/cpa/types';

export const toCpaShopsSuggestModel = (dto: CpaShopsSuggestDto): CpaSearchSuggestModel[] =>
    dto.texts
        .map((item) => ({
            text: item.text,
        }))
        .concat(dto.objects.map((item) => ({ text: item.name, icon: item.overall_icon })));
